module.exports = __webpack_public_path__ + "static/media/background.3fc4663d.png";